import { Box } from '@mui/material';
import React from 'react';
import CircularProgressWithLabel from 'ui-component/display/CircularProgressWithLabel';

interface FileUploadProgressProps {
  interval?: number;
}

const FileUploadProgress: React.FC<FileUploadProgressProps> = ({ interval = 150 }) => {
  const [progress, setProgress] = React.useState(0);

  React.useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) =>
        prevProgress >= 99 ? 99 : prevProgress + 10 >= 99 ? 99 : prevProgress + 10,
      );
    }, interval);
    return () => {
      clearInterval(timer);
    };
  }, [interval]);

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 100,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

        '&::after': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          bgcolor: 'rgba(0, 0, 0, 0.45)',
          backdropFilter: 'blur(2px)',
        },
      }}
    >
      <CircularProgressWithLabel
        value={progress}
        color={'secondary'}
        size={60}
        containerSx={{
          zIndex: 10,
        }}
      />
    </Box>
  );
};

export default FileUploadProgress;
